import Role from '@/store/Role';

/**
 * A factory function for creating navigation guards against users based on roles. Essentially, you give it
 * the name of the role that the current user should have and tie that to a `beforeEnter` property in the router. See the router for examples.
 *
 * @param {String} roleName - name of the role the user should have to navigate to that page
 * @returns a function for managing access to that view by role
 */
export default function(roleName) {
	return (to, from, next) => {
		if (Object.keys(Role.allPermissionsByRole).indexOf(roleName) > -1) {
			// This means they're authorized. Let them through!
			next();
		} else {
			// Hmm...redirect them?
			next({
				name: '404'
			});
		}
	};
}
